import { IssueDetail } from "models/issue";
import { useNavigate } from "react-router";
import { issuePathById, newHireJourneyPathById } from "helpers/url/pages/v1";
import { PrimaryTableButton } from "components/Button/TableButton";
import { ButtonProps } from "@chakra-ui/react";
import { useIssuesByNewHireIdQuery } from "features/Issues/hooks";

interface ResolveIssueButtonProps extends ButtonProps {
  issue?: IssueDetail;
}

export function ResolveIssueButton({ issue, ...rest }: ResolveIssueButtonProps) {
  const navigate = useNavigate();

  if (!issue) {
    return null;
  }

  return (
    <PrimaryTableButton
      onClick={() => navigate(issuePathById(issue?.id))}
      {...rest}
    >
      Resolve
    </PrimaryTableButton>
  );
}

interface ResolveNewHireIssuesButtonProps extends ButtonProps {
  newHireId: string;
}

export function ResolveNewHireIssuesButton({ newHireId, ...rest }: ResolveNewHireIssuesButtonProps) {
  const { data: issues } = useIssuesByNewHireIdQuery(newHireId);
  const navigate = useNavigate();

  if (!newHireId) {
    return null;
  }

  return (
    <PrimaryTableButton
      onClick={() => navigate(issues?.length ? issuePathById(issues[0]?.id) : newHireJourneyPathById(newHireId))}
      {...rest}
    >
      Resolve
    </PrimaryTableButton>
  );
}
